/**
 * Formats required workers amount from Double to display value
 * - Values >= 1.0: rounds up (e.g., 1.1 -> 2)
 * - Values < 1.0 or null/undefined: returns null to indicate "less than 1 worker"
 */
export const formatRequiredWorkers = (amount: number | undefined | null): number | null => {
  if (!amount || amount < 1.0) {
    return null;
  }

  return Math.ceil(amount);
};
